import React, { useEffect, useRef } from "react"
import { Box, TabPanel, Tabs, TabList, Tab } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { AdministrationDashboard } from "./components/RentalDashboard"
import RentalRunningConfiguredContainer from "./components/RentalDashboard/rentalRunning/Container"
import { Button } from "src/mtska-frontend-app-component"

const RentalDashboard = () => {
    const { t } = useTranslation()
    const componentRef = useRef()

    useEffect(() => {
        const isChromium = /(Chrome|Edg|Brave|Chromium)/.test(navigator.userAgent) && !/Firefox/.test(navigator.userAgent)
        if (!isChromium) return

        const style = document.createElement("style")
        style.setAttribute("id", "edge-print-style")
        style.innerHTML = `
		@media print {
			body, html {
				margin: 0 !important;
				padding: 0 !important;
				overflow: visible !important;
				width: 100vw !important;
				height: auto !important;
			}

			#edge-print-wrapper {
				transform: scale(0.75);
				transform-origin: top left;
				width: 100vw !important;
				overflow: visible !important;
				padding: 0 !important;
				margin: 0 !important;
			}

			.dashboard-menu {
				grid-template-columns: repeat(1, 1fr) !important;
				gap: 10px !important;
				padding: 5px !important;
				overflow: visible !important;
			}

			.dashboard-menu > * {
				overflow: visible !important;
			}

			.dashboard-tab-panel {
				height: auto !important;
				overflow: visible !important;
			}
		}
		`
        document.head.appendChild(style)

        return () => {
            document.getElementById("edge-print-style")?.remove()
        }
    }, [])

    return (
        <Box
            id="edge-print-wrapper"
            className="dashboard-menu dashboard-menu-1col"
            sx={{ position: 'relative' }}
        >
            {
                /* <Button onClick={() => window.print()} size="tiny" className="buttonized printbutton" icon="faPrint">
                    {t('print')}
                </Button> */
            }
            <Tabs
                orientation="horizontal"
                size="sm"
                className="dashboard-tabs"
            >
                <TabList className="dashboard-tab-list">
                    <Tab className="dashboard-tab">Stato parco</Tab>
                    <Tab className="dashboard-tab">Stato produzione</Tab>
                </TabList>
                <TabPanel value={0} className="dashboard-tab-panel">
                    <RentalRunningConfiguredContainer ref={componentRef} />
                </TabPanel>
                <TabPanel value={1} className="dashboard-tab-panel">
                    <AdministrationDashboard ref={componentRef} />
                </TabPanel>
            </Tabs>
        </Box>
    )
}

export default RentalDashboard
